<template>
  <van-popup
    class="generalPopup"
    :overlay-style="{
      'background-image':
        'linear-gradient(180deg,#063161 17%,rgba(88,192,237,.8))'
    }"
    v-model="show"
    :close-on-click-overlay="false"
  >
    <div class="tips">
      <div class="close">
        <van-icon name="cross" @click="handleBtn(onClose)" />
      </div>
      <div class="title">{{title}}</div>
      <div class="body" :class="{ 'body-cust': custBody }">
        <div v-if="content">
          <Content :contentProps="contentProps" />
        </div>
        <div v-else v-html="message"></div>
      </div>
      <div v-if="btns && btns.length" class="footer">
        <van-button
          v-for="item in btns"
          :key="item.text"
          @click="handleBtn(item.onPress)"
          class="okBtn"
          round
          type="info"
          size="small"
          >{{ item.text }}</van-button
        >
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "GeneralPopup",
  data: function() {
    return {
      show: true
    };
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    btns: {
      type: Array,
      default: () => [],
      validator: arr => {
        const l = arr.filter(
          item =>
            item.hasOwnProperty("text") &&
            item.hasOwnProperty("onPress") &&
            typeof item.text === "string" &&
            typeof item.onPress === "function"
        ).length;
        return l > 0 || l <= 2;
      }
    },
    message: String,
    content: Object,
    custBody: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.clear();
    },
    handleBtn(event) {
      if (!event) {
        this.clear();
        return false;
      }
      event(this.close);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../style/general.less";
@import "../../../style/constant.less";

.generalPopup {
  background: transparent;
  .tips {
    width: 300px;
    box-sizing: border-box;
    background-color: #ffffff;
    box-shadow: 0px 1px 3px 0px rgba(3, 0, 0, 0.08);
    border-radius: 10px;
    border: solid 1px #e5e5e5;
    text-align: center;
    position: relative;
    padding: 15px 15px;
    overflow: hidden;
  }
  .close {
    display: flex;
    justify-content: flex-end;
    > i {
      font-size: 18px;
      color: rgb(208, 208, 208);
    }
  }
  .title {
    font-size: @font-md-size;
    color: #0096d5;
    opacity: 0.9;
  }
  .body {
    padding: 12px 15px;
    overflow: auto;
    max-height: 350px;
    min-height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: @font-xms-size;
    text-align: left;
    line-height: 17px;
    color: rgba(0,0,0,0.5);
    &.body-cust {
      padding: 0;
      overflow: inherit;
      max-height: inherit;
      display: block;
    }
  }
  .footer {
    display: flex;
    justify-content: space-around;
    padding: 0 0 12px;
    .okBtn {
      width: 45%;
    }
  }
}
</style>
